import { render, staticRenderFns } from "./PostsSelectionFinalCompanies.vue?vue&type=template&id=62310733&"
import script from "./PostsSelectionFinalCompanies.vue?vue&type=script&lang=js&"
export * from "./PostsSelectionFinalCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports